import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ScheduledCommand } from "../Model/ScheduledCommand";

export async function createScheduledCommand(data) {
	let response = await getAPIResponse("/command-scheduler/scheduled-command", data, "POST");
	if (response === null) {
		return null;
	}
	let scheduledCommand = ScheduledCommand.createFromResponseData(response);
	return scheduledCommand;
}